import React from "react";
import { Link } from "react-router-dom";

const BlogCard = () => {
  return (
    <div className="blog-card">
      <div className="card-image">
        <img src="images/blog-1.jpg" className="img-fluid w-100" alt="blog" />
      </div>
      <div className="blog-content">
        <p className="date">1 ديسمبر 2022</p>
        <h5 className="title">نهضة صباح الأحد الجميلة</h5>
        <p className="desc">
        الشركة نفسها هي شركة ناجحة للغاية. ويطلب منا تكليفه بواجباته
        </p>
        <Link to="/blog/:id" className="button">
        اقرأ أكثر
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
